import React from 'react'
import "whatwg-fetch"

import LoadingBox from "../../common/LoadingBox"
import DaumBlogSettings from './daumblog/DaumBlogSettings'
import TistoryBlogSettings from './tistory/TistoryBlogSettings'

import LoadErrorBox from "../../common/LoadErrorBox"
import * as InitStatus from '../../../constants/common/InitializationStatus'
import {DAUMBLOG} from "../../../constants/Service"



export default function ({initialized, role, onRetryInit}) {
  if (initialized === InitStatus.INIT_SUCCESS) {
    return window.Config.service === DAUMBLOG ? <DaumBlogSettings role={role} /> : <TistoryBlogSettings role={role} />
  }

  if (initialized === InitStatus.INIT_DOING) {
    return <LoadingBox />
  }

  return <LoadErrorBox retry={onRetryInit} />
}
